import * as React from "react";
const SvgMSlide = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 526" style={{
    fill: "none"
  }} /><path d="M19 5v14H5V5zm0-2H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2m-4.86 8.86-3 3.87L9 13.14 6 17h12z" data-name="Trazado 527" /></svg>;
export { SvgMSlide as ReactComponent };